export const noop = (...args: any[]): any => {}
